import { defineStore } from 'pinia';
import { Realtime } from 'ably';
import { useUserStore } from './userStore'
import { useBalanceStore } from './balanceStore'
import { useDialogStore } from './dialogStore'
import { usePriceGiftAdenaStore } from './priceGiftAdenaStore'
import axios from 'axios';

export const useAblyStore = defineStore('ably', {
  state: () => ({
    ably: null, // Экземпляр Ably
    error: null, // Ошибка, если что-то пошло не так
    channels: {}, // Активные каналы
  }),

  actions: {
    /**
     * Функция для получения токена Ably с сервера.
     */
    async fetchAblyToken() {
      try {
        const user = useUserStore()
        if (user.user.access_token == null) return false
        axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
        const response = await axios.post('/api/ably-token', {});
        return response.data; // Возвращаем токен
      } catch (error) {
        console.error('Error fetching Ably token:', error);
        throw error;
      }
    },


    async connectToAbly() {
      try {
        this.ably = new Realtime({
          authOptions: {
            isTls: true,
          },
          // Используем authCallback для автоматического обновления токена
          authCallback: async (data, callback) => {
            try {
              const token = await this.fetchAblyToken(); // Получаем новый токен
              callback(null, token); // Возвращаем токен в Ably
            } catch (error) {
              callback(error, null); // Обрабатываем ошибку
            }
          },
        });
        this.ably.connection.on('connected', () => {
          console.log('Connected to Ably');
        });

        this.error = null; // Сбрасываем ошибку
      } catch (error) {
        this.error = 'Failed to connect to Ably';
        console.error('Error connecting to Ably:', error);
        throw error;
      }
    },

    /**

     */
    subscribeToChannel(channelName, messageHandler) {
      if (!this.ably) {
        throw new Error('Ably is not connected');
      }
      console.log(channelName);
      const channel = this.ably.channels.get(channelName);
      console.log(channel);
      channel.on('attached', () => {
        console.log(`Channel attached: user`);
      });

      channel.on('error', (error) => {
        console.error('Error connecting to channel:', error);
      });

      channel.subscribe((message) => {
        console.log('Message received:', message.data);
        if (message.data?.message?.balance !== undefined || message.data?.message?.balance_second !== undefined) {
          const balance = useBalanceStore()
          balance.update_balance_user(message.data.message)

        }
        if (message.data?.message?.your_error_code_id) {
          const user = useUserStore()
          useDialogStore().open_dialog_error_code()
          user.your_error_code = true
        }
        if (message.data?.message?.code_status) {
          const price_data = usePriceGiftAdenaStore()
          price_data.change_code_status(message.data.message)
        }
        messageHandler(message);
      });

      console.log('Subscribed to channel:', channelName);
    },



    unsubscribeFromChannel(channelName) {
      if (this.channels[channelName]) {
        this.channels[channelName].unsubscribe(); // Отписываемся от канала
        delete this.channels[channelName]; // Удаляем канал из состояния
      }
    },

    async testAbly() {
      const user = useUserStore()
      axios.defaults.headers.common['Authorization'] = "Bearer " + user.user.access_token
      const response = await axios.get('/api/testAbly');
      console.log(response.data);


    }

    /**

     */

  },
});
